import type { ListItem, ListMeta } from '@awwyeah/shared';

/**
 * Email-a-list (ROADMAP §2 Phase 1 Lists item 7 / north-star #7): a `mailto:` link with
 * the list rendered as clean plain text. No email service, no network call — the device's
 * own mail app sends it. This is the deliberate v1 scope; see docs/DECISIONS.md.
 */
export function renderListAsText(
  _list: ListMeta,
  items: ListItem[],
  getMemberName: (id: string) => string,
): string {
  const lines: string[] = [];
  const ordered = [...items].sort((a, b) => a.order - b.order);
  for (const item of ordered) {
    if (item.header) {
      lines.push('', item.text.toUpperCase());
      continue;
    }
    const box = item.checked ? '[x]' : '[ ]';
    const detail = item.detail ? ` (${item.detail})` : '';
    const who =
      item.assigneeIds.length > 0 ? ` — ${item.assigneeIds.map(getMemberName).join(', ')}` : '';
    lines.push(`${box} ${item.text}${detail}${who}`);
  }
  return lines.join('\n').trim();
}

export function buildListMailto(
  list: ListMeta,
  items: ListItem[],
  getMemberName: (id: string) => string,
): string {
  const subject = `${list.emoji ? `${list.emoji} ` : ''}${list.name}`;
  const body = renderListAsText(list, items, getMemberName);
  const params = new URLSearchParams({ subject, body });
  // URLSearchParams encodes spaces as '+'; mailto bodies read better with '%20'.
  return `mailto:?${params.toString().replace(/\+/g, '%20')}`;
}
